import { combineReducers } from "redux";
import bios from "./appReducer";

const rootReducer = combineReducers({
  bios,
});

export default rootReducer;
